export const PAYMENT_TYPE_OPTIONS = [
  { value: 1, label: 'One-time tip' },
  { value: 2, label: 'Subscription' },
  { value: 3, label: 'Pay-per-post' },
  { value: 4, label: 'Fundraiser' },
  { value: 5, label: 'Merchant' },
  { value: 6, label: 'Christmas donation' },
  { value: 7, label: 'Pay-per-category' },
  { value: 8, label: 'PPC' },
  { value: 9, label: 'Subscription upgrade' },
];

export const PAYMENT_TYPE_LABELS = PAYMENT_TYPE_OPTIONS.reduce((acc, option) => {
  acc[option.value] = option.label;
  return acc;
}, {});

export function buildPossibleFraudPaymentsListParams(filters) {
  const params = {
    page: filters.page,
    per_page: filters.perPage,
    review_status: filters.reviewStatus,
    currency: filters.currency,
    payment_provider: filters.paymentProvider,
    payment_type: filters.paymentType,
    paid_from: filters.paidFrom,
    paid_to: filters.paidTo,
  };

  Object.keys(params).forEach(key => {
    if (params[key] === null || params[key] === undefined || params[key] === '') {
      delete params[key];
    }
  });

  if (params.payment_type !== undefined) {
    params.payment_type = Number(params.payment_type);
  }

  return params;
}

export function formatPossibleFraudPaymentType(paymentTypeName, paymentType) {
  const normalizedTypeName = paymentTypeName ? String(paymentTypeName).trim() : '';
  if (normalizedTypeName) {
    return normalizedTypeName;
  }

  return PAYMENT_TYPE_LABELS[paymentType]
    || PAYMENT_TYPE_LABELS[Number(paymentType)]
    || paymentType
    || '-';
}

